import React, { useContext } from 'react';

const CollapseContext = React.createContext(false);

export const useCollapse = () => useContext(CollapseContext);
export const CollapseContextProvider = CollapseContext.Provider;
